export default __webpack_public_path__ + "static/media/companyInformationSuccessBackground.751bd787.jpg";